/* ============================================================================
   Tarjeta de producto · "Comprar ahora" con selección de talla inline
   ----------------------------------------------------------------------------
   Patrón tomado de CAT (assets/product-card-hover.js), adaptado al
   snippets/product-block.liquid de Canopy:

   - El botón SIEMPRE dice "Comprar ahora": agrega 1 unidad y va al checkout.
   - Si el producto tiene opciones (talla, color...), se eligen en el overlay de
     la imagen. En desktop aparece al pasar el mouse; en táctil se abre al tocar
     "Comprar ahora" sin opción elegida (en CAT el overlay se oculta en móvil).
   - Las opciones con un único valor disponible se seleccionan solas.
   - Emite el evento GA4 `add_to_cart` (las tarjetas no lo medían) y espera a
     GTM (eventCallback) antes de redirigir, con un tope de tiempo.

   Estilos en assets/hp-card-buy.css. Vanilla JS, sin dependencias.
   ============================================================================ */
(function () {
  'use strict';

  if (window.__hpCardBuy) return;
  window.__hpCardBuy = true;

  var CARD = '[data-hp-card]';

  function rootUrl() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root.charAt(root.length - 1) === '/' ? root : root + '/';
  }

  function readJson(card, selector) {
    var el = card.querySelector(selector);
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function optionButtons(card, name) {
    return Array.prototype.filter.call(card.querySelectorAll('.hp-pch__btn'), function (btn) {
      return btn.getAttribute('data-option-name') === name;
    });
  }

  // --- Estado por tarjeta (se inicializa una vez) -----------------------------
  function state(card) {
    if (card.__hpState) return card.__hpState;
    var s = card.__hpState = {
      variants: readJson(card, '[data-hp-variants]') || [],
      options: readJson(card, '[data-hp-options]') || [],
      selected: {}
    };
    s.options.forEach(function (name) {
      var available = optionButtons(card, name).filter(function (btn) { return !btn.disabled; });
      if (available.length === 1) select(card, available[0]);
    });
    return s;
  }

  function select(card, btn) {
    if (btn.disabled) return;
    var name = btn.getAttribute('data-option-name');
    optionButtons(card, name).forEach(function (b) {
      b.setAttribute('aria-pressed', 'false');
      b.classList.remove('is-selected');
    });
    btn.setAttribute('aria-pressed', 'true');
    btn.classList.add('is-selected');
    state(card).selected[name] = btn.getAttribute('data-option-value');
    clearError(card);
  }

  function missingOptions(card) {
    var s = state(card);
    return s.options.filter(function (name) { return !s.selected[name]; });
  }

  function findVariant(card) {
    var s = state(card);
    if (!s.options.length) return s.variants[0] || null;
    for (var i = 0; i < s.variants.length; i++) {
      var v = s.variants[i];
      var matches = s.options.every(function (name, idx) {
        return v['option' + (idx + 1)] === s.selected[name];
      });
      if (matches) return v;
    }
    return null;
  }

  // --- Feedback ---------------------------------------------------------------
  function showError(card, msg) {
    var el = card.querySelector('[data-hp-error]');
    if (!el) return;
    el.textContent = msg;
    el.hidden = false;
    clearTimeout(card.__hpErrorTimer);
    card.__hpErrorTimer = setTimeout(function () { el.hidden = true; }, 3500);
  }

  function clearError(card) {
    var el = card.querySelector('[data-hp-error]');
    if (el) el.hidden = true;
  }

  function shake(btn) {
    btn.classList.remove('is-error');
    void btn.offsetWidth;
    btn.classList.add('is-error');
    btn.addEventListener('animationend', function () { btn.classList.remove('is-error'); }, { once: true });
  }

  function openPicker(card) { card.classList.add('hp-pch-open'); }
  function closePicker(card) { card.classList.remove('hp-pch-open'); }

  // --- Analítica (GA4 vía dataLayer; pixel de Meta si existe) -----------------
  function trackAddToCart(card, variant, done) {
    var finished = false;
    function finish() { if (!finished) { finished = true; done(); } }

    var price = (Number(variant.price) || 0) / 100;
    var currency = card.getAttribute('data-currency') || undefined;
    var item = {
      item_id: card.getAttribute('data-product-id'),
      item_name: card.getAttribute('data-product-title'),
      item_brand: card.getAttribute('data-product-vendor') || undefined,
      item_variant: variant.title && variant.title !== 'Default Title' ? variant.title : undefined,
      price: price,
      quantity: 1
    };

    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({
        event: 'add_to_cart',
        hp_source: 'product_card_buy_now',
        ecommerce: { currency: currency, value: price, items: [item] },
        eventCallback: finish,
        eventTimeout: 1500
      });
      if (typeof window.fbq === 'function') {
        window.fbq('track', 'AddToCart', {
          content_ids: [item.item_id],
          content_type: 'product_group',
          value: price,
          currency: currency
        });
      }
    } catch (e) { /* la analítica nunca bloquea la compra */ }

    // Si GTM no está cargado, eventCallback no se llama: tope de seguridad.
    setTimeout(finish, 1200);
  }

  // --- Comprar ahora ------------------------------------------------------------
  function buyNow(card, btn) {
    var missing = missingOptions(card);
    if (missing.length) {
      openPicker(card);
      showError(card, 'Selecciona ' + missing.join(' y ').toLowerCase());
      shake(btn);
      return;
    }

    var variant = findVariant(card);
    if (!variant || !variant.available) {
      openPicker(card);
      showError(card, 'Esa opción no está disponible');
      shake(btn);
      return;
    }

    btn.disabled = true;
    card.classList.add('is-buying');

    fetch(rootUrl() + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variant.id, quantity: 1 }] })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('cart/add ' + response.status);
        trackAddToCart(card, variant, function () {
          window.location.href = rootUrl() + 'checkout';
        });
      })
      .catch(function () {
        btn.disabled = false;
        card.classList.remove('is-buying');
        showError(card, 'No se pudo agregar. Intenta de nuevo.');
        shake(btn);
      });
  }

  // --- Eventos (delegados: funcionan con tarjetas cargadas por AJAX) ---------
  document.addEventListener('click', function (e) {
    var optionBtn = e.target.closest('.hp-pch__btn');
    if (optionBtn) {
      var optionCard = optionBtn.closest(CARD);
      if (!optionCard) return;
      e.preventDefault();
      e.stopPropagation();
      state(optionCard);
      select(optionCard, optionBtn);
      return;
    }

    var buyBtn = e.target.closest('[data-hp-buy]');
    if (buyBtn) {
      var buyCard = buyBtn.closest(CARD);
      if (!buyCard) return;
      e.preventDefault();
      buyNow(buyCard, buyBtn);
      return;
    }

    // Tocar fuera de una tarjeta cierra su selector abierto (táctil).
    Array.prototype.forEach.call(document.querySelectorAll(CARD + '.hp-pch-open'), function (card) {
      if (!card.contains(e.target)) closePicker(card);
    });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' && e.key !== 'Esc') return;
    Array.prototype.forEach.call(document.querySelectorAll(CARD + '.hp-pch-open'), closePicker);
  });

  // Pre-selecciona opciones únicas en las tarjetas ya presentes y en las que
  // el Theme Editor recarga.
  function initAll(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll(CARD), state);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
